"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceKey = exports.reducer = exports.ogBetProviderActions = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const REDUCER_KEY = 'ogBetProvider';
const initialState = {
    modal: null,
};
const ogBetSlice = (0, toolkit_1.createSlice)({
    name: REDUCER_KEY,
    initialState,
    reducers: {
        setQuickBetModal: (state, { payload }) => {
            state.modal = payload;
        },
        confirmQuickBet: (state, { payload }) => { },
    },
});
exports.ogBetProviderActions = ogBetSlice.actions, exports.reducer = ogBetSlice.reducer, exports.sliceKey = ogBetSlice.name;
//# sourceMappingURL=slice.js.map